<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
      :custom-footer-style="'position: fixed;bottom: 0px;right: 0px;background-color: var(--card-bg);width: 100%'"
    >
      <template slot="conteudo">
        <b-row
          v-if="abaAcessada == 0"
          no-gutters
        >
          <b-col class="text-right">
            <dropdown-tag
              ref="tagContratante"
              :tags="tagsContratante"
              grupo-tags="Contratante"
              legenda="Tag Contratante"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagSocio"
              :tags="tagsSocio"
              grupo-tags="Sócio"
              legenda="Tag Sócio"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagProposta"
              :tags="tagsProposta"
              grupo-tags="Proposta"
              legenda="Tag Proposta"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagAssinatura"
              :tags="tagsAssinatura"
              grupo-tags="Assinatura"
              legenda="Tag Assinatura"
              @enviar-pai="addTagTemplate"
            />

            <b-btn
              size="sm"
              variant="info"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="$refs.fileInput.click()"
            >
              <font-awesome-icon
                :icon="faFileUpload"
                style="font-size:15px !important;width:20px"
              /> Importar .docx
            </b-btn>

            <b-btn
              id="imprimir-documento"
              size="sm"
              variant="primary"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="imprimir"
            >
              <font-awesome-icon
                :icon="faPrint"
                style="font-size:15px !important;width:20px"
              />Imprimir</b-btn>
          </b-col>
        </b-row>
        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            ref="geral"
            no-body
            title="Editor de Texto"
          >
            <div
              v-if="abaAcessada == 0"
            >
              <b-row>
                <b-col>
                  <fieldset class="font-weight-bold text-muted small">
                    Aqui você configura o template do contrato utilizando as ferramentas disponíveis no editor de texto.
                  </fieldset>
                </b-col>
                <b-col cols="12">
                  <hr
                    class="mx-0 mt-0 mb-2"
                    style="border-top: 1px solid #a3a4a66b !important;"
                  >
                </b-col>
                <b-col cols="12">
                  <editor
                    ref="tinymceEditor"
                    v-model="form.contrato"
                    api-key="rw08hrnrxbws6bwi1g8vajfilhyq7tr75s79uq8sp49np6h0"
                    :init="tinymceInit"
                    style="padding-bottom: 5%;"
                  />
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab
            no-body
            title="Perfil do Template"
          >
            <aba-parametrizacao
              v-if="abaAcessada == 1"
              ref="parametrizacao"
              titulo="Perfil do template"
              descricao="Aqui você parametriza o perfil do template, através desses dados é feito o vínculo com a proposta de forma automática"
              :value="form"
            />
          </b-tab>
        </b-tabs>

        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>

        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".docx"
          @change="handleDocxUpload"
        >

      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.card-header{
  padding-bottom: 0px !important;
}
</style>

<script>
import Editor from '@tinymce/tinymce-vue'
import mammoth from 'mammoth'

import {
  required,
} from '@validations'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPrint,
  faTags,
  faFileUpload,
} from '@fortawesome/free-solid-svg-icons'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import AbaParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/components/cadatro-parametrizacao/CadastroParametrizacao.vue'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/services/api'
import apiUsuarioInterno from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'CadastroTemplate',
  components: {
    Editor,
    CadastroBase,
    AbaParametrizacao,
    FontAwesomeIcon,
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  data() {
    return {
      faPrint,
      faTags,
      faFileUpload,
      required,
      form: {
        template: 'contrato',
        tipoTemplate: 'nenhum',
        contrato: '',
      },
      abaAcessada: 0,
      templateOptions: [
        { value: 'contrato', text: 'Contrato' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transeferencia', text: 'Proposta honorários empresas em transferência' },
      ],
      tagsContratante: ['Nome', 'CPF/CNPJ', 'Endereço', 'Nome Sócio Representante', 'CPF Sócio Representante'],
      tagsSocio: ['Nome', 'CPF/CNPJ', 'Endereço', 'Profissão', 'Função', 'Estado Civil', 'Nacionalidade', 'Data de nascimento', 'Início repetição', 'Final repetição'],
      tagsProposta: ['Serviços eventuais', 'Serviços recorrentes', 'Serviços avulsos', 'Valor contrato (R$)', 'Valor serviços não-recorrentes (R$)', 'Valor serviços recorrentes (R$)', 'Valor contrato (Extenso)', 'Data início vigência contrato', 'Data atual contrato', 'Checklist Perguntas e Respostas', 'Checklist Perguntas Respostas e Valor'],
      tagsAssinatura: ['Início assinatura sócio', 'Assinatura sócio', 'Final assinatura sócio', 'Assinatura Responsável', 'Assinatura Testemunha'],
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,

      tinymceInit: {
        plugins: 'lists advlist link image code table wordcount autolink anchor searchreplace visualblocks fullscreen media',
        toolbar: 'undo redo | formatselect | bold italic backcolor | '
          + 'alignleft aligncenter alignright alignjustify | '
          + 'bullist numlist outdent indent | removeformat | '
          + 'link image media code table | fullscreen',

        menubar: true,
        min_height: 300,
        max_height: 700,
        entity_encoding: 'raw',
        forced_root_block: false,
        extended_valid_elements: 'span[class|style|data-tag]',
      },
    }
  },
  created() {
    if (this.$route.path.indexOf('editar') > 0) {
      this.state = 'editar'
      this.carregar(this.$route.params.id)
    } else {
      this.state = 'novo'
    }
  },
  methods: {
    handleDocxUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const input = event.target
      input.value = null

      const reader = new FileReader()

      reader.onload = loadEvent => {
        const arrayBuffer = loadEvent.target.result

        mammoth.convertToHtml({ arrayBuffer })
          .then(result => {
            const html = result.value

            const { editor } = this.$refs.tinymceEditor

            if (editor) {
              editor.setContent(html)
            }
          })
          .catch(() => {
            this.$erro('Falha na conversão do arquivo .docx.')
          })
      }

      reader.readAsArrayBuffer(file)
    },

    insertTagWithCurrentStyle(tagText) {
      const { editor } = this.$refs.tinymceEditor
      if (!editor) return

      const node = editor.selection ? editor.selection.getNode() : null

      let baseNode = node
      if (baseNode && baseNode.nodeType !== 1) {
        baseNode = baseNode.parentNode
      }

      const fontFamily = baseNode ? editor.dom.getStyle(baseNode, 'font-family', true) : ''
      const fontSize = baseNode ? editor.dom.getStyle(baseNode, 'font-size', true) : ''
      const color = baseNode ? editor.dom.getStyle(baseNode, 'color', true) : ''

      const safeText = editor.dom.encode(tagText)

      editor.insertContent(
        `<span class="template-tag" data-tag="${safeText}" style="`
        + `font-family:${fontFamily || 'inherit'};`
        + `font-size:${fontSize || 'inherit'};`
        + `color:${color || 'inherit'};`
        + `"><strong style="font-weight:inherit">${safeText}</strong></span>&nbsp;`,
      )
    },

    carregar(id) {
      api.getTemplateById(id)
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.go(-1)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor) {
          this.form.contrato = this.$refs.tinymceEditor.editor.getContent()
        }
        this.form.contrato = this.form.contrato.replace(/[\u200B-\u200D\uFEFF]/g, '')
        if (this.state === 'novo') {
          api.salvarTemplate(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTemplate(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    addTagTemplate(value) {
      if (value.includes('{Assinatura Assinatura Responsável}') || value.includes('{Assinatura Assinatura Testemunha}')) {
        this.tagAtual = value

        const aplicarFiltroUsuarios = () => {
          if (value.includes('Responsável')) {
            this.usuariosFiltrado = this.usuarios.filter(fil => fil.docuSignResponsavel)
          } else {
            this.usuariosFiltrado = this.usuarios.filter(fil => fil.docuSignTestemunha)
          }
        }

        if (!this.usuarios || this.usuarios.length === 0) {
          apiUsuarioInterno.getUsuariosMarcacaoDocuSign()
            .then(payload => {
              this.usuarios = payload.data
              aplicarFiltroUsuarios()
              this.$refs.modalUsuarioDocusign.show()
            })
        } else {
          aplicarFiltroUsuarios()
          this.$refs.modalUsuarioDocusign.show()
        }
      } else {
        this.insertTagWithCurrentStyle(value)
      }
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)
      this.insertTagWithCurrentStyle(tag)

      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
    imprimir() {
      const winPrint = window.open('', '', 'left=0,top=0,bottom=100,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      let conteudoEditor = this.form.contrato
      if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor) {
        conteudoEditor = this.$refs.tinymceEditor.editor.getContent()
      }

      if (conteudoEditor) {
        winPrint.document.write(`<!DOCTYPE html>
        <html xmlns="http://www.w3.org/1999/xhtml">
          <head>
              <title>Print Test</title>
              <style type="text/css" media="print">
              @page 
              {
                  size:  auto;
                  margin: 0mm;
              }

              html
              {
                  background-color: #FFFFFF; 
                  margin: 0px;
              }

              body
              {
                  border: solid 1px white ;
                  margin: 10mm 15mm 10mm 15mm;
              }
              </style>
          </head>
          <body>
            <div>
              ${conteudoEditor}
            </div>
          </body>
        </html>`)
      }

      winPrint.document.close()
      winPrint.focus()
      winPrint.print()
      winPrint.close()
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
    },
  },
}
</script>
